import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const sessionToken = searchParams.get('session_token');
    const appId = searchParams.get('app_id');

    // If no token, redirect to login page
    if (!sessionToken) {
      navigate('/login');
      return;
    }

    // Verify app_id matches
    if (appId && appId !== 'fleet_share') {
      setError('Invalid app_id');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    // Automatically login with token from HUB
    handleAutoLogin(sessionToken);
  }, []);

  const handleAutoLogin = async (token) => {
    try {
      console.log('Auto-logging in with HUB token...');
      await login(token);
      console.log('Login successful, redirecting to dashboard...');
      navigate('/');
    } catch (error) {
      console.error('Auto-login failed:', error);
      setError('Authentication failed. Please try again.');
      setTimeout(() => navigate('/login'), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--background))] flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-lg text-red-600 mb-2">
              {error}
            </div>
            <div className="text-sm text-[hsl(var(--text-secondary))]">
              Redirecting to login...
            </div>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[hsl(var(--brand-primary))] mx-auto mb-4"></div>
            <div className="text-lg text-[hsl(var(--text-primary))] mb-2">
              Authenticating with HUB...
            </div>
            <div className="text-sm text-[hsl(var(--text-secondary))]">
              Please wait while we verify your session
            </div>
          </>
        )}
      </div>
    </div>
  );
}
